/** @format */

import React from "react";
import { ReactComponent as LifePreserver } from "bootstrap-icons/icons/life-preserver.svg";
import { useTranslation } from "react-i18next";
import { useLocale } from "../../i18n/hooks";
import { useGetUserQuery } from "../../app/services/userApi";
import "./HelpLink.scss";

type Props = {
  className?: string;
  locationId?: string;
  position?:
    | "top-start"
    | "top-end"
    | "bottom-end"
    | "bottom-start"
    | "inherit";
};

const HelpLink: React.FC<Props> = ({
  className,
  locationId = "",
  position = "top-end",
}) => {
  const { t: _ } = useTranslation();
  const locale = useLocale();
  const { data: user, isLoading } = useGetUserQuery();

  let guideURL: string | undefined;
  switch (user?.role) {
    case "wjec":
      guideURL =
        "http://resource.download.wjec.co.uk/vtc/editable-bl-docs/staff.html";
      break;
    case "teacher":
      guideURL =
        locale === "cy"
          ? "https://resource.download.wjec.co.uk/vtc/editable-bl-docs/athrawon.html"
          : "http://resource.download.wjec.co.uk/vtc/editable-bl-docs/teacher.html";
  }

  let _position = "";
  switch (position) {
    case "top-start":
      _position = "position-absolute top-0 start-0";
      break;
    case "top-end":
      _position = "position-absolute top-0 end-0";
      break;
    case "bottom-end":
      _position = "position-absolute bottom-0 end-0";
      break;
    case "bottom-start":
      _position = "position-absolute bottom-0 start-0";
      break;
  }

  return isLoading || guideURL === undefined ? (
    <></>
  ) : (
    <a
      className={`z-2 ${className ?? "px-3 py-1 help-link"} ${_position}`}
      href={guideURL + `#${locationId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <small>
        {_("Help & support")}
        <LifePreserver className="ms-1" style={{ verticalAlign: "-0.25em" }} />
      </small>
    </a>
  );
};

export default HelpLink;
